(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.DaisyCartSubmit = api;
})(typeof window !== 'undefined' ? window : globalThis, function () {
  'use strict';

  function create(options) {
    options = options || {};
    var request = options.fetch || fetch;
    var schedule = options.setTimeout || setTimeout;
    var cancel = options.clearTimeout || clearTimeout;
    var active = null;
    var root = options.root || '/';

    function readCart() {
      return request(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } }).then(function (r) {
        if (!r.ok) throw new Error('The basket could not be checked.');
        return r.json();
      });
    }

    function reviewError(message) {
      var error = new Error(message + ' Please review your basket before adding again.');
      error.reviewCart = true;
      return error;
    }

    function completeLines(lines, expected) {
      if (!Array.isArray(lines)) return false;

      var groups = {};
      lines.forEach(function (line) {
        var properties = line && line.properties;
        var attempt = properties && properties['_Daisy cart attempt'];
        var item = properties && properties['_Daisy cart item'];
        if (attempt == null || item == null) return;
        var key = String(attempt) + '::' + String(item);
        if (!groups[key]) groups[key] = [];
        groups[key].push(line);
      });

      var matched = expected.map(function (item) {
        var attempt = item.properties && item.properties['_Daisy cart attempt'];
        var marker = item.properties && item.properties['_Daisy cart item'];
        var group = groups[String(attempt) + '::' + String(marker)] || [];
        if (!group.length) return null;

        var valid = group.every(function (line) {
          return Number(line.variant_id || line.id) === item.id &&
            Object.keys(item.properties).every(function (key) {
              var actual = line.properties && line.properties[key];
              return String(actual == null ? '' : actual) === String(item.properties[key] == null ? '' : item.properties[key]);
            });
        });
        if (!valid) return null;

        var quantity = group.reduce(function (sum, line) {
          return sum + Number(line.quantity || 0);
        }, 0);
        return quantity === item.quantity ? group : null;
      });

      return expected.every(function (item, index) {
        var group = matched[index];
        if (!group) return false;

        var parentKeys = item.parent_line_key ? [item.parent_line_key] : [];
        if (item.parent_id) {
          var parentIndex = expected.findIndex(function (candidate) { return candidate.id === item.parent_id; });
          var parentGroup = parentIndex >= 0 ? matched[parentIndex] : null;
          if (!parentGroup) return false;
          parentKeys = parentGroup.map(function (line) { return line.key; }).filter(Boolean);
          if (!parentKeys.length) return false;
        }

        if (!parentKeys.length) return true;
        return group.every(function (line) {
          var parentKey = line.parent_relationship && line.parent_relationship.parent_key;
          return parentKeys.indexOf(parentKey) !== -1;
        });
      });
    }

    function add(items, onSlow) {
      if (active) return active;
      var attempt = 'daisy-' + Date.now() + '-' + Math.random().toString(36).slice(2);
      var expected = items.map(function (item, index) {
        if (!Number.isSafeInteger(Number(item.id)) || Number(item.id) <= 0 || !Number.isSafeInteger(Number(item.quantity)) || Number(item.quantity) < 1) {
          throw new Error('A selected option is unavailable. Please refresh the page.');
        }
        var line = { id: Number(item.id), quantity: Number(item.quantity), properties: Object.assign({}, item.properties, { '_Daisy cart attempt': attempt, '_Daisy cart item': String(index) }) };
        if (item.parent_id) line.parent_id = Number(item.parent_id);
        if (item.parent_line_key) line.parent_line_key = item.parent_line_key;
        return line;
      });
      var timer = schedule(function () { if (onSlow) onSlow(); }, options.slowAfter || 12000);
      var explicitRejection = false;
      active = request(root + 'cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: expected })
      }).then(function (response) {
        explicitRejection = response.status >= 400 && response.status < 500;
        return response.json().catch(function () { return {}; }).then(function (body) {
          if (!response.ok) throw new Error(body.description || body.message || 'The selected options could not be added.');
          if (!body || !completeLines(body.items, expected)) throw new Error('The basket response was incomplete.');
          return body;
        });
      }).catch(function (error) {
        return readCart().then(function (cart) {
          var own = (cart.items || []).filter(function (line) { return line.properties && line.properties['_Daisy cart attempt'] === attempt; });
          if (completeLines(own, expected)) return { recovered: true, items: own };
          if (!explicitRejection) throw reviewError('We could not confirm whether everything was added.');
          if (!own.length) throw error;
          var updates = {};
          own.forEach(function (line) { updates[line.key] = 0; });
          return request(root + 'cart/update.js', {
            method: 'POST', credentials: 'same-origin',
            headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: updates })
          }).then(function (r) {
            if (!r.ok) throw reviewError('Some options were added, but the basket could not be restored.');
            return readCart();
          }).then(function (current) {
            if ((current.items || []).some(function (line) { return line.properties && line.properties['_Daisy cart attempt'] === attempt; })) {
              throw reviewError('Some options may still be in your basket.');
            }
            throw error;
          });
        }, function () { throw reviewError('We could not confirm the basket contents.'); });
      }).then(function (result) {
        cancel(timer);
        active = null;
        return result;
      }, function (error) {
        cancel(timer);
        if (!error.reviewCart) active = null;
        throw error;
      });
      return active;
    }

    return { add: add };
  }

  return { create: create };
});
